import { useModal } from '@/hooks';
import { useCallback, useEffect } from 'react';

const useHasUnsavedChangesModal = ({
  hasUnsavedChanges,
  canModalOpen,
  handleConfirmTabSwitch,
  setHasUnsavedChanges,
  clearUnsavedChanges,
  handleDeclineTabSwitch,
  isTrackingEnabled = true,
}: {
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: () => void;
  clearUnsavedChanges: () => void;
  canModalOpen: boolean;
  handleConfirmTabSwitch: () => void;
  handleDeclineTabSwitch: () => void;
  // View-only roles cannot save, so their edits must not be tracked as unsaved changes.
  isTrackingEnabled?: boolean;
}) => {
  const { isOpened, openModal, closeModal } = useModal();

  const handleValuesChange = useCallback(() => {
    if (isTrackingEnabled && !hasUnsavedChanges) {
      setHasUnsavedChanges();
    }
  }, [isTrackingEnabled, hasUnsavedChanges, setHasUnsavedChanges]);

  const onConfirmTabSwitchAndCloseModal = () => {
    closeModal();
    clearUnsavedChanges();
    handleConfirmTabSwitch();
  };

  const onCloseModal = () => {
    closeModal();
    handleDeclineTabSwitch();
  };

  useEffect(() => {
    if (canModalOpen && hasUnsavedChanges) {
      openModal();
    }
  }, [canModalOpen, hasUnsavedChanges]);

  return { isOpened, onCloseModal, onConfirmTabSwitchAndCloseModal, handleValuesChange };
};

export default useHasUnsavedChangesModal;
